export default "__VITE_ASSET__e7d94442__"